<div class="chatbot-startscreen">
  <div class="chatbot-welcome-frame">
    <div class="intro">
      <div class="avatar">
        <img src="assets/icons/chatbot/JayIcon.svg" class="icon-svg" alt="Jay Avatar Icon">
      </div>
      <div class="message">
          <h2> {{__('Hello')}}</h2>
          <h5> {{__('HelloDescription')}}</h5>
          <h4>{{__('Message')}}</h4>
      </div>
    </div>
  </div>
  @if(isMeshModeAvailable){
    <div class="chatbot-mesh-mode-tip">
      <p class="tip-text">
        <b>{{__('mesh-mode-tip-1')}}</b> {{__('mesh-mode-tip-2')}}
      </p>
      <div class="show-more-button-container">
        <button class="show-more-button" (click)="toggleExpand()">
          <clr-icon shape="angle" [class.rotated]="isExpanded"></clr-icon>
          @if(isExpanded){
            {{__('mesh-mode-tip-4')}}
          }
          @else{
            {{__('mesh-mode-tip-3')}}
          }
        </button>
      </div>
      <div class="expandable-tip" [class.expanded]="isExpanded">
        <p class="tip-text top-expandable-text">
          <b>{{__('mesh-mode-tip-5')}}</b> {{__('mesh-mode-tip-6')}}
        </p>
        <p class="tip-text top-expandable-text">
          <b>{{__('mesh-mode-tip-6-1')}}</b> {{__('mesh-mode-tip-6-2')}}
        </p>
        <p class="tip-text">
          <b>{{__('mesh-mode-tip-7')}}</b> {{__('mesh-mode-tip-8')}}
        </p>
        <p class="tip-text">
          <b>{{__('mesh-mode-tip-9')}}</b>
        </p>
        <div>
          <p class="tip-text">
            {{__('mesh-mode-tip-10')}} {{__('mesh-mode-tip-11')}}
          </p>
        </div>
      </div>
    </div>
  }
  <div class="chatbot-suggestions">
    <div class="suggestions-frame">
      <ng-container *ngFor="let suggestion of suggestionList">
        <div (click)="sendMessage(suggestion.title, suggestion.content)" class="suggestion">
          <div class="suggestion-text">
            <div class="suggestion-text-frame">
              <h6>{{suggestion.title}}</h6>
              <p *ngIf="suggestion.hint" class="suggestion-hint">{{suggestion.hint}}</p>
              <p *ngIf="suggestion.content">"{{suggestion.content}}"</p>
            </div>
          </div>
          <div class="suggestion-img-wrapper">
            <img alt="send message" src="assets/icons/ID37_Chatbot_IconSend_Filled.svg"/>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
